import moment from 'moment'
import {
  CLOSE_RULES_WARNING_DIALOG,
  CLOSE_MODAL,
  OPEN_MODAL,
  SET_ACTIVE_RULE,
  SET_ACTIVE_PROJECT,
  SET_RULE_EDITOR,
  SET_RULES_LOG_SETTINGS
} from 'actions'

const originalTime = moment.utc()
const initialState = {
  isWarningDialogOpen: true,
  editor: {
    isEditing: false,
    value: ''
  },
  overview: {
    isModalOpen: false,
    activeRule: null,
    activeProject: null
  },
  log: {
    originalTime,
    type: 'inbound',
    interval: 'hours',
    time: moment(originalTime).startOf('hour').toISOString()
  }
}

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case CLOSE_RULES_WARNING_DIALOG:
      return {
        ...state,
        isWarningDialogOpen: false
      }
    case SET_RULE_EDITOR:
      return {
        ...state,
        editor: payload
      }
    case OPEN_MODAL:
      return {
        ...state,
        overview: {
          ...state.overview,
          isModalOpen: true
        }
      }
    case CLOSE_MODAL:
      return {
        ...state,
        overview: {
          ...state.overview,
          isModalOpen: false,
          activeRule: null,
          activeProject: null
        }
      }
    case SET_ACTIVE_RULE:
      return {
        ...state,
        overview: {
          ...state.overview,
          activeRule: payload
        }
      }
    case SET_ACTIVE_PROJECT:
      return {
        ...state,
        overview: {
          ...state.overview,
          activeProject: payload
        }
      }
    case SET_RULES_LOG_SETTINGS:
      const interval = payload.interval
      let time = payload.time || state.log.time

      if (interval) {
        let startOf
        if (interval === 'hours') {
          startOf = 'hour'
        } else if (interval === 'days') {
          startOf = 'day'
        } else if (interval === 'months') {
          startOf = 'month'
        }
        time = moment(state.log.originalTime).startOf(startOf).toISOString()
      }

      return {
        ...state,
        log: {
          ...state.log,
          ...payload,
          time
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/application/rules.js